import { ChevronDown } from "react-feather";
import { useContext, useEffect, useState } from "react";
import { ReactComponent as USER_ICON } from "../../../../assets/icons/userIcon.svg";
import { DataContext } from "../../../../Context/DataContext";
import { NotificationContext } from "../../../../Context/NotificationContext";
import { firestore, getFullHttpUrl } from "../../../../firebase.config";
import axios from "axios";
import { FormTextInput } from "../../../../Components/FormTextInput";
import NewButton from "../../../../NewComponents/NewButton";


const TeamInviteComponent = ({invitedMembers, setInvitedMembers}) => {
    const [email, setEmail] = useState("");
    const [showMemberType, setShowMemberType] = useState(false);
    const [showMemberTypeInvite, setShowMemberTypeInvite] = useState(false);
    const [memberType, setMemberType] = useState("Member");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const {userData, teamData} = useContext(DataContext);

    const [addMemberBtn, setAddMemberBtn] = useState("Add User");

    const {showNotification} = useContext(NotificationContext);

    const emailRegex = new RegExp(
        "^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$"
      );

      const addUser = async() => {
        if(!email || !firstName) {
            showNotification("Error", "Please, fill all the fields.", "error");
            return;
        }

        if(!emailRegex.test(email)) {
            showNotification("Error", "Please, insert a valid email.", "error");
            return;
        }

        setAddMemberBtn("Adding...");
        const data = {
          name: firstName + " " + lastName,
          firstName: firstName,
          lastName: "lastName",
          email: email.toLowerCase(),
          teamData: teamData,
          teamRole: memberType,
          userInvited: userData.id,
        };
        setInvitedMembers([...invitedMembers, data]);
        localStorage.setItem("invitedMembers", JSON.stringify([...invitedMembers, data]));
        setEmail("");
        setFirstName("");
        setLastName("");
        setShowMemberType(false);
        setAddMemberBtn("Add User");
        setShowMemberType(false);
      
    }

    const removeInvite = (email) => {
        setInvitedMembers(invitedMembers.filter((member) => member.email !== email));
    }

    const handleUpdateMemberType = (email, type) => {
      setShowMemberTypeInvite(false);
      const newInvitedMembers = invitedMembers.map((member) => member.email === email ? {...member, teamRole: type} : member);
      setInvitedMembers(newInvitedMembers);
      localStorage.setItem("invitedMembers", JSON.stringify(newInvitedMembers));
    }


    return (
      <div className='flex flex-col justify-center items-start gap-[24px] w-full'>

        <div className='flex flex-col justify-center items-start gap-[16px] w-full'>

            <div className='flex justify-center items-center gap-4 w-full'>
            <FormTextInput placeholder="First Name" value={firstName} onChange={setFirstName} showBorderOnValue={true} showBorderOnFocus={true} disabled={addMemberBtn === "Sending..."}/>
            <FormTextInput placeholder="Last Name" value={lastName} onChange={setLastName} showBorderOnValue={true} showBorderOnFocus={true} disabled={addMemberBtn === "Sending..."}/>
            </div>

            <div className='flex justify-center items-center gap-4 w-full'>
                <FormTextInput placeholder="Email" value={email} onChange={setEmail} showBorderOnValue={true} showBorderOnFocus={true} disabled={addMemberBtn === "Sending..."}/>
                <div className='relative flex justify-center items-center gap-2 color-[#030F23] cursor-pointer select-none' onClick={() => setShowMemberType(!showMemberType)}>
                  <div className='onBoarding-description capitalize select-none'>{memberType}</div>
                  <ChevronDown width={16}/>

                  {showMemberType && <div className='absolute top-[120%] left-[20px] w-max bg-[#fff] rounded-[8px] shadow-md z-10'>
                      <p className='onBoarding-description px-4 py-2 hover:bg-[#F7F6F7] cursor-pointer' onClick={() => setMemberType("member")}>Member</p>
                      <div className='w-full h-[1px] bg-[#E6E7E9]'/>
                      <p className='onBoarding-description px-4 py-2 hover:bg-[#F7F6F7] cursor-pointer' onClick={() => setMemberType("admin")}>Admin</p>
                  </div>}
                </div>
                <NewButton text={addMemberBtn} icon={false} onClick={addUser} width='max-content' disabled={addMemberBtn === "Sending..." ||  email === "" || firstName === ""}/>
            </div>

      </div>


      {invitedMembers.length > 0 && <div className='flex flex-col justify-center items-start gap-[24px] w-full'>
          <p className='onBoarding-description font-[500]'>Team Members Invites</p>
          <div className='customScroll flex flex-col justify-start items-start gap-[16px] w-full pr-[20px]'>
            {invitedMembers.map((member, i) => (
              <div className='flex justify-between items-center gap-4 w-full'>
              <div className='flex justify-center items-center gap-4'>
                <USER_ICON/>
                <p className='onBoarding-description'>{member.email}</p>
              </div>

              <div className='flex justify-center items-center gap-4'>
              <div className='relative flex justify-center items-center gap-2 color-[#030F23] cursor-pointer select-none' onClick={() => showMemberTypeInvite ? setShowMemberTypeInvite(false) : setShowMemberTypeInvite(member.email)}>
                  <div className='onBoarding-description capitalize select-none'>{member.teamRole}</div>
                  <ChevronDown width={16}/>

                  {showMemberTypeInvite === member.email && <div className='absolute top-[120%] left-[20px] w-max bg-[#fff] rounded-[8px] shadow-md z-10'>
                      <p className='onBoarding-description px-4 py-2 hover:bg-[#F7F6F7] cursor-pointer' onClick={() => handleUpdateMemberType(member.email, "member")}>Member</p>
                      <div className='w-full h-[1px] bg-[#E6E7E9]'/>
                      <p className='onBoarding-description px-4 py-2 hover:bg-[#F7F6F7] cursor-pointer' onClick={() => handleUpdateMemberType(member.email, "admin")}>Admin</p>
                  </div>}
                </div>
                <div className='onBoarding-description capitalize cursor-pointer' style={{color: "#12ABBF"}} onClick={() => removeInvite(member.email)}>Remove</div>
              </div>

            </div>
            )
          )}
        </div>
          
        </div>}
      </div>
    )
  }

  export default TeamInviteComponent;